module.exports = __webpack_public_path__ + "static/img/lxwe_add4.c65aa3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lxwe_add4.png
// module id = PqEP
// module chunks = 0